<div class="row column">
	<p class="giftshop-hint" [innerHTML]="'giftshop.list.hint' | translate"></p>
</div>
<div #listElement class="shop-product-list giftshop-product-list row column" *ngIf="products && products.length > 0">
	<div giftshop-list-item (click)="setActiveItem(product)" class="small-12 medium-6 large-4 xlarge-3" [class.inactive]="activeProduct && activeProduct !== product" [class.active]="activeProduct && activeProduct === product" [currency]="donation.currencySymbol" [product]="product" [selected]="activeProduct === product" (addItem)="addItemToChart($event)" *ngFor="let product of products | slice:0:page * itemsPerPage"></div>
</div>
<div class="shop-product-list-empty row column text-center" *ngIf="products && products.length === 0" [innerHTML]="'shop.list.noproducts' | translate"></div>

<div class="shop-list-more row column" *ngIf="products && (products.length > page * itemsPerPage)">
	<a (click)="page = page + 1" [innerHTML]="'shop.list.more' | translate"></a>
</div>






